// filepath: src/utils/heightRange.js
// Provides mapping from person height (cm) to recommended desk sitting and standing heights
// Based on ergonomic research: sitting ≈ height × 0.40, standing ≈ height × 0.64
// These values assume proper 90-degree elbow angle while typing
const heightRangeCM = [
  [150, 60, 95],
  [151, 60, 96],
  [152, 61, 97],
  [153, 61, 98],
  [154, 62, 98],
  [155, 62, 99],
  [156, 62, 100],
  [157, 63, 100],
  [158, 63, 101],
  [159, 64, 102],
  [160, 64, 102],
  [161, 64, 103],
  [162, 65, 104],
  [163, 65, 104],
  [164, 66, 105],
  [165, 66, 106],
  [166, 66, 106],
  [167, 67, 107],
  [168, 67, 107],
  [169, 68, 108],
  [170, 68, 109],
  [171, 68, 109],
  [172, 69, 110],
  [173, 69, 111],
  [174, 70, 111],
  [175, 70, 112],
  [176, 70, 113],
  [177, 71, 113],
  [178, 71, 114],
  [179, 72, 115],
  [180, 72, 115],
  [181, 72, 116],
  [182, 73, 116],
  [183, 73, 117],
  [184, 74, 118],
  [185, 74, 118],
  [186, 74, 119],
  [187, 75, 120],
  [188, 75, 120],
  [189, 76, 121],
  [190, 76, 122],
  [191, 76, 122],
  [192, 77, 123],
  [193, 77, 123],
  [194, 78, 124],
  [195, 78, 125],
  [196, 78, 125],
  [197, 79, 126],
  [198, 79, 127],
  [199, 80, 127],
  [200, 80, 128],
  [201, 80, 129],
  [202, 81, 129],
  [203, 81, 130],
  [204, 82, 131],
  [205, 82, 131]
];

export default heightRangeCM;
